export const DEFAULT_DECK = [
    { type: 'S', value: 'K', numValue: 13, color: 'black', isFaceDown: true },
    { type: 'C', value: 'K', numValue: 13, color: 'black', isFaceDown: true },
    { type: 'D', value: 'K', numValue: 13, color: 'red', isFaceDown: true },
    { type: 'H', value: 'K', numValue: 13, color: 'red', isFaceDown: true },
    { type: 'S', value: 'Q', numValue: 12, color: 'black', isFaceDown: true },
    { type: 'C', value: 'Q', numValue: 12, color: 'black', isFaceDown: true },
    { type: 'D', value: 'Q', numValue: 12, color: 'red', isFaceDown: true },
    { type: 'H', value: 'Q', numValue: 12, color: 'red', isFaceDown: true },
    { type: 'S', value: 'J', numValue: 11, color: 'black', isFaceDown: true },
    { type: 'C', value: 'J', numValue: 11, color: 'black', isFaceDown: true },
    { type: 'D', value: 'J', numValue: 11, color: 'red', isFaceDown: true },
    { type: 'H', value: 'J', numValue: 11, color: 'red', isFaceDown: true },
    { type: 'S', value: '10', numValue: 10, color: 'black', isFaceDown: true },
    { type: 'C', value: '10', numValue: 10, color: 'black', isFaceDown: true },
    { type: 'D', value: '10', numValue: 10, color: 'red', isFaceDown: true },
    { type: 'H', value: '10', numValue: 10, color: 'red', isFaceDown: true },
    { type: 'S', value: '9', numValue: 9, color: 'black', isFaceDown: true },
    { type: 'C', value: '9', numValue: 9, color: 'black', isFaceDown: true },
    { type: 'D', value: '9', numValue: 9, color: 'red', isFaceDown: true },
    { type: 'H', value: '9', numValue: 9, color: 'red', isFaceDown: true },
    { type: 'S', value: '8', numValue: 8, color: 'black', isFaceDown: true },
    { type: 'C', value: '8', numValue: 8, color: 'black', isFaceDown: true },
    { type: 'D', value: '8', numValue: 8, color: 'red', isFaceDown: true },
    { type: 'H', value: '8', numValue: 8, color: 'red', isFaceDown: true },
    { type: 'S', value: '7', numValue: 7, color: 'black', isFaceDown: true },
    { type: 'C', value: '7', numValue: 7, color: 'black', isFaceDown: true },
    { type: 'D', value: '7', numValue: 7, color: 'red', isFaceDown: true },
    { type: 'H', value: '7', numValue: 7, color: 'red', isFaceDown: true },
    { type: 'S', value: '6', numValue: 6, color: 'black', isFaceDown: true },
    { type: 'C', value: '6', numValue: 6, color: 'black', isFaceDown: true },
    { type: 'D', value: '6', numValue: 6, color: 'red', isFaceDown: true },
    { type: 'H', value: '6', numValue: 6, color: 'red', isFaceDown: true },
    { type: 'S', value: '5', numValue: 5, color: 'black', isFaceDown: true },
    { type: 'C', value: '5', numValue: 5, color: 'black', isFaceDown: true },
    { type: 'D', value: '5', numValue: 5, color: 'red', isFaceDown: true },
    { type: 'H', value: '5', numValue: 5, color: 'red', isFaceDown: true },
    { type: 'S', value: '4', numValue: 4, color: 'black', isFaceDown: true },
    { type: 'C', value: '4', numValue: 4, color: 'black', isFaceDown: true },
    { type: 'D', value: '4', numValue: 4, color: 'red', isFaceDown: true },
    { type: 'H', value: '4', numValue: 4, color: 'red', isFaceDown: true },
    { type: 'S', value: '3', numValue: 3, color: 'black', isFaceDown: true },
    { type: 'C', value: '3', numValue: 3, color: 'black', isFaceDown: true },
    { type: 'D', value: '3', numValue: 3, color: 'red', isFaceDown: true },
    { type: 'H', value: '3', numValue: 3, color: 'red', isFaceDown: true },
    { type: 'S', value: '2', numValue: 2, color: 'black', isFaceDown: true },
    { type: 'C', value: '2', numValue: 2, color: 'black', isFaceDown: true },
    { type: 'D', value: '2', numValue: 2, color: 'red', isFaceDown: true },
    { type: 'H', value: '2', numValue: 2, color: 'red', isFaceDown: true },
    { type: 'S', value: 'A', numValue: 1, color: 'black', isFaceDown: true },
    { type: 'C', value: 'A', numValue: 1, color: 'black', isFaceDown: true },
    { type: 'D', value: 'A', numValue: 1, color: 'red', isFaceDown: true },
    { type: 'H', value: 'A', numValue: 1, color: 'red', isFaceDown: true },
]
